module.exports = "/_next/static/images/ExtraInfo@3x-fee844bfe4fb810f57ba8d72a283d6c4.png";